import { Component, input, OnInit } from '@angular/core';

import { BadgeComponent } from '@vendasta/galaxy/badge';
import { GalaxyPopoverModule, PopoverPositions } from '@vendasta/galaxy/popover';
import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { TranslateModule } from '@ngx-translate/core';
import { AiAssistant } from '../../core/interfaces/ai-assistant.interface';
import { AiAssistantPipesModule } from '../../pipes/src/pipes.module';

@Component({
  selector: 'ai-rating-badge',
  imports: [
    BadgeComponent,
    GalaxyPopoverModule,
    CdkOverlayOrigin,
    TranslateModule,
    AiAssistantPipesModule
],
  templateUrl: './rating-badge.component.html',
  styleUrl: './rating-badge.component.scss',
})
export class RatingBadgeComponent implements OnInit {
  readonly label = input('');
  readonly value = input(0);
  readonly max = input(4);
  readonly aiAssistant = input.required<AiAssistant>();
  protected levels: number[] = [];
  protected PopoverPositions = PopoverPositions;
  protected showPopover = false;

  ngOnInit(): void {
    this.levels = [...Array(this.max()).keys()];
  }

  togglePopover(): void {
    this.showPopover = !this.showPopover;
  }

  closePopover(): void {
    this.showPopover = false;
  }
}
